/**
 *
 * TextArea Component
 *
 */

import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

/**
 *  @deprecated
 *  @example
 *
 *  Use `@material-ui/core/TextField` instead.
 *
 *  ```
 *  <TextField value="Words" onChange={onChange} />
 *  ```
 */
const TextArea = props => {
  const classes = useStyles();
  return (
    <TextField
      aria-label="textarea-detail-field"
      className={classes.textfield}
      InputProps={{
        classes: {
          root: classes.inputRoot,
        },
      }}
      multiline
      variant="outlined"
      {...props}
    />
  );
};

TextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default TextArea;
